import types from "../types"

/* Create */
function fetch(engine, model, query = {}, options = {}) {
  if (!engine) {
    throw new Error(`engine required`)
  }
  return {
    type: types.fetch,
    engine,
    model,
    query,
    options,
  }
}

fetch.success = function fetchSuccess(engine, model, query, data, meta) {
  if (!engine) {
    throw new Error(`engine required`)
  }
  return {
    type: types.fetchSuccess,
    engine,
    model,
    query,
    data,
    meta,
  }
}

fetch.error = function fetchError(engine, model, query, error) {
  if (!engine) {
    throw new Error(`engine required`)
  }
  return {
    type: types.fetchSuccess,
    engine,
    model,
    query,
    error,
  }
}

fetch.cancel = function fetchCancecl(
  engine,
  model,
  query,
  reason = `No reason`,
) {
  if (!engine) {
    throw new Error(`engine required`)
  }
  return {
    type: types.fetchCancel,
    engine,
    model,
    query,
    reason,
  }
}

export default fetch
